import { createAction, props } from '@ngrx/store';

export const setTableConfigValue = createAction(
    '[Table Column config Tab] Set Table column config value',
    props<{ tableColumn: string }>()
);
